import { render, staticRenderFns } from "./PButton.vue?vue&type=template&id=924cdcf0&scoped=true&"
import script from "./PButton.vue?vue&type=script&lang=ts&"
export * from "./PButton.vue?vue&type=script&lang=ts&"
import style0 from "./PButton.vue?vue&type=style&index=0&id=924cdcf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924cdcf0",
  null
  
)

export default component.exports